import { useQuery } from '@tanstack/react-query';
import { api } from '@/services/api';
import type { SearchResult } from '@jerico/shared';

interface SearchResponse {
  results: SearchResult[];
}

export function useGlobalSearch(query: string, type?: string) {
  return useQuery({
    queryKey: ['search', query, type],
    queryFn: () => {
      const params = new URLSearchParams({ q: query });
      if (type) params.append('type', type);
      return api.get<SearchResponse>(`/search?${params.toString()}`);
    },
    enabled: query.length >= 2,
  });
}
